import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';

@Component({
  tag: 'pnk-checkbox',
  styleUrl: 'pnk-checkbox.css',
})
export class PnkCheckbox {
  @Prop({ mutable: true, reflect: true }) value: string = '';

  @Prop({ mutable: true, reflect: true }) checked: boolean = false;

  @Prop() disabled: boolean = false;

  @Event() changed!: EventEmitter<boolean>;

  handleChange(ev: Event) {
    const target = ev.target as HTMLInputElement;
    this.value = target.checked.toString();
    this.checked = target.checked;
    this.changed.emit(this.checked);
  }

  render() {
    const style = {
      'pnk-appearance-none pnk-w-6 pnk-h-6 pnk-bg-disabled-base pnk-rounded pnk-cursor-pointer ': !this.checked && !this.disabled,
      'pnk-w-6 pnk-h-6 pnk-bg-accent pnk-border-4 pnk-border-disabled-text pnk-rounded pnk-appearance-none ': this.checked && this.disabled,
      'pnk-appearance-none pnk-w-6 pnk-h-6 pnk-bg-disabled-text pnk-rounded ': !this.checked && this.disabled,
      'pnk-appearance-none  pnk-rounded pnk-bg-accent pnk-border-4 pnk-cursor-pointer  pnk-w-6 pnk-h-6': this.checked && !this.disabled,
    };
    return (
      <div class="pnk-text-center pnk-flex pnk-align-middle pnk-flex-row pnk-gap-1">
        <input class={style} type="checkbox" onChange={ev => this.handleChange(ev)} disabled={this.disabled} checked={this.checked} value={this.checked.toString()}></input>

        <span>
          <slot />
        </span>
      </div>
    );
  }
}
